import ScheduleType from "./ScheduleType";

export type ScheduleGridClient = {
  first_name?: string | null;
};

export type ScheduleGridSlot = {
  id: number;
  date: string;
  status: number;
  consultant_id: number;
  video_call: number;
  note?: string | null;
  client?: ScheduleGridClient | null;
  outcome?: "scheduled" | "video" | "completed" | "no_show" | null;
  has_card?: boolean;
};

export type ScheduleGridConsultant = {
  id: number;
  first_name: string;
  city: string;
};

export type ScheduleGridCommercialRegion = {
  relevance_order: number;
  name: string;
};

export type SlotVisualKind =
  | "empty"
  | "free"
  | "blocked"
  | "scheduled"
  | "video"
  | "mixed"
  | "completed"
  | "no_show";

export type ResolvedScheduleCell = {
  coord: string;
  visualKind: SlotVisualKind;
  displayStatus: number;
  primarySlotId: number;
  appointments: ScheduleGridSlot[];
  blockedNote: string | null;
  hasNote: boolean;
  clientSummary: {
    badge: string | null;
    label: string;
    tooltip: string;
  };
};

export { ADM_MAX_VISITS_PER_SLOT as MAX_CLIENTS_DISPLAYED_PER_SLOT } from "./scheduleSlotVisitLimit";

export const ACTIVE_SLOT_STATUSES = [
  ScheduleType.LOCKED,
  ScheduleType.UNLOCKED,
  ScheduleType.SCHEDULED,
] as const;
